'use client';

import { useEffect } from 'react';
import Link from 'next-intl/link';
import { useLocale, useTranslations } from 'next-intl';
import { MdArrowForwardIos } from 'react-icons/md';
import { setTitleTag } from '@/src/utils/titleTag';
import { useLocaleRoutes } from '@/src/utils/useLocaleRoutes';
import getOption from '@/src/utils/getOption';
import ContactSidebarLayout from '@components/ContactSidebarLayout';

import en from './en.json';
import no from './no.json';
import sv from './sv.json';
import de from './de.json';
import pl from './pl.json';
import fi from './fi.json';

const contents = {
  en,
  no,
  sv,
  de,
  pl,
  fi,
};

export default function ClientPage() {
  const locale = useLocale();
  const t = useTranslations('navigation');
  const path = useLocaleRoutes();

  const content = contents[locale as keyof typeof contents];
  const title = content.title;
  useEffect(() => {
    setTitleTag(title);
  }, [title]);

  const links = [
    {
      url: path('about'),
      text: t('about'),
    },
    {
      url: path('why-ats'),
      text: t('whyATS'),
    },
    {
      url: path('faq'),
      text: t('faq'),
      hide: !getOption('HAS_AUCTIONS'),
    },
    {
      url: path('terms'),
      text: t('terms'),
    },
    {
      url: path('privacy'),
      text: t('privacy'),
    },
    {
      url: path('cookie-policy'),
      text: t('cookies'),
    },
    /*{
      url: path('transparency-act'),
      text: t('transparency-act'),
    },*/
  ];

  return (
    <>
      <ContactSidebarLayout
        image='/images/pages/customer-center.jpg'
        title={title}
      >
        <p className='mb-8 text-xl text-brand'>{content.intro}</p>
        <div className='accordion flex flex-col gap-2'>
          {links.map((link, index) => {
            if (link?.hide) {
              return null;
            }
            return (
              <Link
                href={link.url}
                key={index}
                className={`flex w-full items-center justify-between bg-accent p-4 py-2 text-left font-bold text-white hover:bg-accent/70`}
              >
                {link.text}
                <MdArrowForwardIos />
              </Link>
            );
          })}
        </div>
      </ContactSidebarLayout>
    </>
  );
}
